import script from "./SpinnerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinnerComp.vue?vue&type=script&setup=true&lang=js"

import "./SpinnerComp.vue?vue&type=style&index=0&id=1b10fe3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b10fe3b"]])

export default __exports__